// BillToForm.js - Added Document ID field (CIF, NIF, Passport number)
import React from 'react';
import Form from 'react-bootstrap/Form';
import { useTranslation } from 'react-i18next';

const BillToForm = ({ billTo, billToEmail, billToAddress, billToDocumentId, editField }) => {
  const { t } = useTranslation();

  return (
    <div>
      <Form.Label className="fw-bold" htmlFor="bill-to">{t('billTo')}</Form.Label>
      
      <Form.Group className="mb-2">
        <Form.Control 
          placeholder={t('billToPlaceholder')}
          value={billTo} 
          type="text" 
          name="billTo" 
          onChange={editField} 
          autoComplete="name" 
          required 
        />
      </Form.Group>

      <Form.Group className="mb-2">
        <Form.Control 
          placeholder={t('documentIdPlaceholder')}
          value={billToDocumentId} 
          type="text" 
          name="billToDocumentId" 
          onChange={editField} 
          autoComplete="off"
        />
      </Form.Group>
      
      <Form.Group className="mb-2">
        <Form.Control 
          placeholder={t('emailPlaceholder')}
          value={billToEmail} 
          type="email" 
          name="billToEmail" 
          onChange={editField} 
          autoComplete="email" 
          required 
        />
      </Form.Group>
      
      <Form.Group className="mb-2">
        <Form.Control
          as="textarea"
          rows={2}
          placeholder={t('addressPlaceholder')}
          value={billToAddress} 
          name="billToAddress" 
          onChange={editField} 
          autoComplete="address" 
          required 
          style={{ resize: 'vertical' }} // Optional: allows vertical resize only
        />
      </Form.Group>

    </div>
  );
};

export default BillToForm;